class JDConstants {
  static NOTICEPERIODOPTIONS = [
    {
      value: "",
      text: "Please select an option",
      disabled: true,
    },
    {
      value: "immediate",
      text: "Immediate",
    },
    {
      value: "15 days",
      text: "15 days",
    },
    {
      value: "30 days",
      text: "30 days",
    },
    {
      value: "2 months",
      text: "2 months",
    },
    {
      value: "3 months",
      text: "3 months",
    },
  ];
  static PANELISTOPTIONS = [
    {
      value: "allpanelist",
      text: "Select All Panelists",
    },
    {
      value: "partpanelist",
      text: "Select One or More Panelists",
    },
    {
      value: "nopanelist",
      text: "No Internal Panelist",
    },
  ];
  static EDUCATIONOPTIONS = [
    {
      value: "",
      text: "Please select an option",
      disabled: true,
    },
    {
      value: "highschool",
      text: "High School",
    },
    {
      value: "UG",
      text: "UG",
    },
    {
      value: "PG",
      text: "PG",
    },
    {
      value: "PHD",
      text: "PHD",
    },
  ];
  static EXPOPTIONS = [
    {
      value: "",
      text: "Please select an option",
      disabled: true,
    },
    {
      value: "0-2",
      text: "Fresher(0-2 years)",
    },
    {
      value: "2-4",
      text: "Junior(2-4 years)",
    },
    {
      value: "4-6",
      text: "Senior(4-6 years)",
    },
    {
      value: "6-8",
      text: "Lead(6-8 years)",
    },
    {
      value: "8-12",
      text: "Management(8-12 years)",
    },
    {
      value: "others",
      text: "12+ years",
    },
  ];
  static ROLES = [
    {
      value: "",
      text: "Please select an option",
      disabled: true,
    },
    {
      value: "tester",
      text: "Tester",
    },
    {
      value: "developer",
      text: "Developer",
    },
    {
      value: "others",
      text: "Others",
    },
  ];
  static TIMEOPTIONS = [
    {
      value: "hrs",
      text: "Hours",
    },
    {
      value: "mins",
      text: "Minutes",
    },
    {
      value: "days",
      text: "Days",
    },
  ];
  static PRIORITYOPTIONS = [
    {
      item: "first",
      name: "First",
    },
    {
      item: "last",
      name: "Last",
    },
    {
      item: "highestScored",
      name: "Highest Scored",
    },
  ];
  static SHOWJDOPTIONS = [
    {
      value: 1,
      text: "Basic",
    },
    {
      value: 2,
      text: "All",
    },
  ];
  static TESTOPTIONS = [
    {
      value: "public",
      text: "Public",
    },
    {
      value: "private",
      text: "Private",
    },
  ];
  static SHIFTOPTIONS = [
    {
      item: false,
      name: "Day",
    },
    {
      item: true,
      name: "Night",
    },
  ];
  static GENDEROPTIONS = [
    {
      item: "male",
      name: "Male",
    },
    {
      item: "female",
      name: "Female",
    },
    {
      item: "both",
      name: "Both",
    },
  ];

  static JOBTYPES = [
    {
      value: "",
      text: "Please select an option",
      disabled: true,
    },
    {
      value: "temporary resource",
      text: "Temporary Resource",
    },
    {
      value: "full time",
      text: "Full Time",
    },
    {
      value: "freelancer",
      text: "Freelancer",
    },
    {
      value: "contract",
      text: "Contract",
    },
  ];
}

export default JDConstants;
